import { useServices } from 'core/common/hooks';
import { ModalHeader, Modal } from 'core/common/ui/ui-kit';
import PaymentThreeDomainSecure from '../PaymentThreeDomainSecure';

export type PaymentThreeDomainSecureDialogProps = {
  isOpen?: boolean;
  onClose?: () => void;
  onSucceed?: () => void;
};

export const PaymentThreeDomainSecureDialog = ({
  isOpen = false,
  onSucceed,
  onClose,
}: PaymentThreeDomainSecureDialogProps) => {
  const { analyticsService } = useServices();

  const close = () => {
    analyticsService.trackEvent('three_domain_secure_closed');

    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal open={isOpen}>
      <ModalHeader onClose={close} />
      <PaymentThreeDomainSecure onSucceed={onSucceed} />
    </Modal>
  );
};
